import React, { forwardRef } from 'react';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/userMembers.module.scss';
//hooks
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//comp
import Hr from 'src/webapp/views/component/HorizontalLine';//세로줄
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import EmptyData from 'src/webapp/views/component/data/EmptyData';//데이터없음

const List = forwardRef((props, scrollRef) => {
    const list = props.list;
    const { stateFilter } = useComnHook();//상태필터

    return ( 
        <>
        {list.length > 0 ? 
            <Element tag={`div`} className={styles.listArea} propRef={el => (scrollRef.current = el)}>
                <Element tag={`ul`}>
                    {list.map((item, i) => (
                        <Element tag={`li`} key={i}>
                            <Element tag={`div`}><Element tag={`label`} style={{width: "7.24rem"}}>{item.PARTNER_NAME}</Element></Element><Hr />
                            <Element tag={`div`}><Element tag={`label`} style={{width: "3.24rem"}}>{item.MEMBER_NAME}</Element></Element><Hr />
                            <Element tag={`div`}><Element tag={`span`} style={{width: "11.94rem"}}>예약일 {item.REG_DT}</Element></Element><Hr/>
                            <Element tag={`div`}><Element tag={`span`} style={{width: "11.94rem"}}>방문일 {item.RESERV_DT}</Element></Element><Hr/>
                            <Element tag={`div`}><Element tag={`span`} style={{width: "9.24rem"}}>{item.MODEL_KOR_NAME}</Element></Element><Hr/>
                            <Element tag={`div`}><Element tag={`span`} style={{width: "5.24rem"}}>{item.RESERV_ITEM}</Element></Element><Hr/>
                            <Element tag={`div`} className={[styles.stretch, ("state" + item.STATE)].join(" ")}><Element tag={`label`}>{stateFilter(item.STATE)}</Element></Element>
                            <Element tag={`div`}><FontAwesomeIcon icon="fa-light fa-chevron-right" /></Element>
                        </Element>
                    ))}
                </Element>
            </Element>
        : <EmptyData /> }
        </>
    );
})
export default List;